import React from 'react'
import {components, GroupBase, MultiValueProps} from 'react-select'
import {MAX_VISIBLE_TAGS, TSelectOption, TTagsCollapseSelectProps} from '../_types'

export const CollapsedMultiValue: React.FC<
    MultiValueProps<TSelectOption, boolean, GroupBase<TSelectOption>>
> = (props) => {
    const {isTagsExpanded, onToggleTagsExpanded} =
        props.selectProps as unknown as TTagsCollapseSelectProps
    const allValues = props.getValue() as TSelectOption[]
    const overflowCount = allValues.length - MAX_VISIBLE_TAGS
    const isLast = props.index === allValues.length - 1

    const handleBadgeClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        onToggleTagsExpanded()
    }

    if (isTagsExpanded) {
        return (
            <>
                <components.MultiValue {...props} />
                {isLast && (
                    <div
                        className='componentSelect__overflow-badge componentSelect__overflow-badge--collapse'
                        onMouseDown={handleBadgeClick}
                    >
                        ↑
                    </div>
                )}
            </>
        )
    }

    if (props.index < MAX_VISIBLE_TAGS) {
        return <components.MultiValue {...props} />
    }

    if (props.index === MAX_VISIBLE_TAGS) {
        return (
            <div className='componentSelect__overflow-badge' onMouseDown={handleBadgeClick}>
                +{overflowCount}
            </div>
        )
    }

    return null
}